export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ऑफर"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["मेरे ट्रेड"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["मेरे विज्ञापन"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ट्रेड"])}
}